export default __webpack_public_path__ + "static/media/github.c03eb29a.svg";